/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_2Inputs */

const en_pc_online_compat_2 = /** @type {(inputs: Pc_Online_Compat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything runs in your tab's memory, so very large or image-heavy PDFs are slower than in the desktop app. If a big file struggles, switch to the desktop version.`)
};

const zh_pc_online_compat_2 = /** @type {(inputs: Pc_Online_Compat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有处理都在标签页内存中进行，因此特别大或图片很多的 PDF 会比桌面版慢。如果大文件处理吃力，请改用桌面版。`)
};

/**
* | output |
* | --- |
* | "Everything runs in your tab's memory, so very large or image-heavy PDFs are slower than in the desktop app. If a big file struggles, switch to the desktop ve..." |
*
* @param {Pc_Online_Compat_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_2 = /** @type {((inputs?: Pc_Online_Compat_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_2(inputs)
	return zh_pc_online_compat_2(inputs)
});
export { pc_online_compat_2 as "pc.online.compat.2" }